import { FunctionComponent } from 'react'
import loginStyles from './styles'
import { Illustration } from '@/components/HideIllustrationsExternal'
import { Text, getTheme } from '@conexasaude/conexa-hero'
import TimeZoneLuxon from '../TimeZoneLuxon'
import { PageLayoutProps } from './types'

const PageLayout: FunctionComponent<PageLayoutProps> = props => {
  const { children, customFooter } = props
  const styles = loginStyles()
  const theme = getTheme()

  return (
    <div css={styles.containerIcon}>
      <div css={styles.containerBackground}>
        <div css={styles.backgroundContainer}>
          <div css={styles.backgroundNoise} />
          <Illustration
            name="system"
            css={styles.backgroundContainerIcon}
            width="560px"
          />
          <Text
            variant="headingXLarge"
            color={theme.colors.background.white}
            css={styles.backgroundContainerTitle}
          >
            Saúde digital do jeito que você precisa
          </Text>
          <Text
            variant="headingMedium"
            color={theme.colors.background.white}
            css={styles.backgroundContainerSubtitle}
          >
            Conecte-se com profissionais de saúde e tenha atendimento onde e
            quando precisar.
          </Text>
        </div>
      </div>
      <div css={styles.container}>
        <div css={styles.content}>{children}</div>
        <div css={styles.footer}>
          {customFooter ?? null}
          <TimeZoneLuxon />
          <Text
            renderAs="span"
            variant="microCopy"
            color={theme.colors.neutral[200]}
          >
            © 2021 Conexa Saúde · Todos os direitos reservados.
          </Text>
        </div>
      </div>
    </div>
  )
}

export default PageLayout
